import React from 'react';

import {
  AttributeList,
  AttributeItem,
} from 'scenes/Gallery/components/AttributeList';
import { Tile } from 'scenes/Gallery/components/Tiles';

import ConversionGroupPreviewScreenLink from 'scenes/Gallery/ConversionPages/ConversionGroups/ConversionGroupPreviewScreenLink';

import {
  COLUMN_ID,
  COLUMN_PREVIEW,
  COLUMN_NAME,
  COLUMN_APPLICATION,
  COLUMN_FLOW,
} from './constants';

const ConversionGroupsTile = ({ data, isSelected, onSelect }) => {
  const {
    [COLUMN_ID]: id,
    [COLUMN_PREVIEW]: preview,
    [COLUMN_NAME]: name,
    [COLUMN_APPLICATION]: application,
    [COLUMN_FLOW]: flow,
    conversionPageCount,
    isNew,
  } = data;

  return (
    <Tile
      selected={isSelected(data)}
      onSelect={onSelect(data)}
      id={id}
      name={name}
      previewSrc={preview}
      renderPreview={({ previewComponent }) => (
        <ConversionGroupPreviewScreenLink id={id}>
          {previewComponent}
        </ConversionGroupPreviewScreenLink>
      )}
      heightCover={true}
      title={
        <ConversionGroupPreviewScreenLink id={id}>
          {name}
        </ConversionGroupPreviewScreenLink>
      }
      content={application?.name}
      attributesPreview={
        <AttributeList
          type={'icon'}
          variant={'chips'}
          justifyContent={'end'}
          p={1}
        >
          {isNew ? <AttributeItem valueParser={'new'} /> : null}
        </AttributeList>
      }
      attributes={
        <AttributeList>
          <AttributeItem
            valueParser={'conversionPagesCount'}
            value={conversionPageCount}
          />
          <AttributeItem valueParser={'cpFlow'} value={flow?.name} />
        </AttributeList>
      }
    />
  );
};

export default ConversionGroupsTile;
